import gql from 'graphql-tag';
import client from '../graphqlAPI';

const GET_ADMIN_PRO_RESERVATIONS = gql`
query getAdminProReservations($email: String, $name: String, $eventSlugName: String, $payed: Boolean, $startDate: String, $finishDate: String, $from: Int, $to: Int, $sortingField: String, $sortingType: Int, $getTotal: Boolean) {
  getAdminProReservations(email: $email, name: $name, eventSlugName: $eventSlugName, payed: $payed, startDate: $startDate, finishDate: $finishDate, from: $from, to: $to, sortingField: $sortingField, sortingType: $sortingType, getTotal: $getTotal) {
      isAuth
      total
      reservations {
        _id
        userName
        userLastname
        userEmail
        userId
        eventName
        eventSlugName
        sessionDateTime
        artistSetSlugName
        payed
        createdAt
      }
    }
  }
`;

const getAdminProReservations = async (variables) => {
  try {
    const result = await client.query({
      query: GET_ADMIN_PRO_RESERVATIONS,
      variables,
      errorPolicy: 'all',
      fetchResults: true,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { getAdminProReservations: reservationsData } } = result;

    if (reservationsData) {
      return reservationsData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getAdminProReservations = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getAdminProReservations Error: ${error}`);
    return null;
  }
};

export default getAdminProReservations;
